"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experience = void 0;
var react_1 = require("react");
var Experience;
(function (Experience) {
    Experience["DoorDash"] = "doordash";
    Experience["Caviar"] = "caviar";
    Experience["Storefront"] = "storefront";
})(Experience = exports.Experience || (exports.Experience = {}));
var createNamedContext = function (name) {
    var context = react_1.createContext({});
    context.displayName = name;
    return context;
};
var ExperienceRouterContext = createNamedContext('ExperienceRouter');
exports.default = ExperienceRouterContext;
